import React, { useState } from 'react'
import { Box, Text, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, Button, Stack, Flex, useDisclosure } from '@chakra-ui/react'
import { IAdditionalServices } from 'services/IApi.d'
import { AddIcon } from '@chakra-ui/icons'
import { useOfferingProvider } from 'providers/offeringProvider/OfferingProvider'
import { moneyFormat } from 'utils/functions/formatNumber'
import IBModalAction from 'components/common/IBModalAction/IBModalAction'

interface AdditionalServiceListProps {
  idKey: string
  service: IAdditionalServices
  selected: boolean
}

const AdditionalService = ({ idKey, service, selected }: AdditionalServiceListProps) => {
  const { selectedOfferings, setSelectedOfferings } = useOfferingProvider()
  const [isAdded, setIsAdded] = useState<boolean>(selected)
  const { isOpen: isOpenModalPrice, onOpen: onOpenModalPrice, onClose: onCloseModalPrice } = useDisclosure()

  const handleAddService = (serviceSelection: IAdditionalServices) => {
    const updatedServices = [...selectedOfferings.additionalServices, serviceSelection]
    setSelectedOfferings({
      ...selectedOfferings,
      additionalServices: updatedServices
    })
  }

  const handleDeleteService = (serviceToDelete: IAdditionalServices) => {
    const updatedServices = selectedOfferings.additionalServices.filter(s => s.codeDn !== serviceToDelete.codeDn)
    setSelectedOfferings({
      ...selectedOfferings,
      additionalServices: updatedServices,
    })
  }

  const handleButtonClick = () => {
    if (isAdded) {
      handleDeleteService(service)
    } else {
      handleAddService(service)
    }
    setIsAdded(!isAdded)
  }

  return (
    <Box data-testid='additional-service-id' p='3px' borderRadius="lg" border={isAdded ? '2px solid' : 'none'} borderColor={isAdded ? 'primary.500' : 'none'} mb={4}>
      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="flex-start" alignSelf="stretch" borderRadius='lg' overflow='hidden' border='1px solid' borderColor='secondary.60' color='grey.120'>
        <Accordion width="100%" allowToggle>
          <AccordionItem key={idKey} mt={4} borderTop="0" borderBottom={1} >
            <AccordionButton _hover={{ bg: 'none' }} _expanded={{ borderBottom: '1px solid', borderColor: 'secondary.500' }}>
              <Box flex="1" textAlign="left" textStyle='h6'>
                {service.denomination}
              </Box>
              <AccordionIcon fontSize='20px' color='primary.500' />
            </AccordionButton>
            <AccordionPanel p={0} >
              <Box pb={3} pt={3} pl={4} textStyle='labelMd' >
                {service.description}
              </Box>
            </AccordionPanel>
          </AccordionItem>
          <Box display="flex" justifyContent="space-between" alignItems="center" borderTop='1px solid' borderTopColor='secondary.60' >
            <Stack pl={4}>
              {service.type === 'variable' &&
                <Box pt={3} align-items='baseline'>
                  <Text textStyle='labelMd'> Desde </Text>
                </Box>
              }
              <Box pb={0} pt={0} align-items='baseline'>
                <Text textStyle='h6' display="inline-block" verticalAlign="bottom" mr={1}>{moneyFormat(service.price, 'ARS')}</Text>
                <Text textStyle='labelMdBold' display="inline-block" verticalAlign="bottom"> +IVA por mes</Text>
              </Box>
              {service.type === 'variable' &&
                <Flex pb={4} align="center">
                <Text textStyle='labelMd' verticalAlign="bottom"> Precio variable sujeto a condiciones del servicio <Button data-testid='viewDescriptionPrice' textStyle='labelMd' variant='primary-text' onClick={onOpenModalPrice}> Ver precios</Button></Text>
              </Flex>

              }
            </Stack>

            <Box pb={4} pt={3} pl={4} pr={4}>
              <Button
                data-testid="additionalService-promocion-add"
                leftIcon={isAdded ? null : <AddIcon boxSize={2} />}
                color='primary.500'
                variant='primary-outline'
                onClick={handleButtonClick}>
                {isAdded ? 'Quitar' : 'Agregar'}
              </Button>
            </Box>
          </Box>
        </Accordion>
      </Box>
      <IBModalAction
        isOpen={isOpenModalPrice}
        onClose={onCloseModalPrice}
        buttonAction={onCloseModalPrice}
        buttonActionText='Entendido'
        title={`Precios del servicio de ${service.codeDn.toLocaleLowerCase() === 'trd' ? service.denomination : service.denomination.toLowerCase()  }`}
        textBody={service.note}
        iconView='info'
      />
    </Box>

  )

}

export default AdditionalService 